import { Page } from "@tfg/ui"
import { Navigate, useLocation } from "react-router-dom"

import { resolveBrandShellRedirectPath } from "~/pages/brandShellAccess"
import { useAuth } from "~/store/auth-context"

export const HomeWrapper = () => {
  const { user, getHomeRedirectUrl } = useAuth()
  const { pathname } = useLocation()
  if (!user) {
    return <Navigate to="/login" replace={true} />
  }
  const supplierRedirectPath = resolveBrandShellRedirectPath(
    user,
    getHomeRedirectUrl,
    pathname
  )
  if (supplierRedirectPath !== null) {
    return <Navigate to={supplierRedirectPath} replace={true} />
  }
  return <Page title="Dashboard" />
}
